import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Button } from '../../buttons'
import { SimpleModal } from '../../modal/simple-modal'
import { FONTS } from '../../../constants'

export const ConfirmChangeStatusForm = (props) => {
  const { open, clickChangeStatus } = props

  const actions = (
    <ButtonGroup>
      <Button
        theme='#28a745'
        width='70px'
        height='26px'
        onClick={ () => clickChangeStatus('confirm') }
      >
        Save
      </Button>
      <Button
        theme='#6c757d'
        width='70px'
        height='26px'
        onClick={ () => clickChangeStatus('cancel_confirm') }
      >
        Cancel
      </Button>
    </ButtonGroup>
  )

  const descriptions = (
    <DescWrapper>
      <DescText>The following features cannot be edit later on implementing status</DescText>
      <DescItem>1. Project’s Contract price</DescItem>
      <DescItem>
        2. Type, Product Name, Cost and Price in Cost Planning [Other Services, License/MA and Hardware/MA]
      </DescItem>
    </DescWrapper>
  )

  return (
  /* eslint no-underscore-dangle: 0 */
    <SimpleModal
      isOpen={ open }
      title='This action cannot be undone'
      description={ descriptions }
      actions={ actions }
      toggle={ () => clickChangeStatus('cancel_confirm') }
    />
  )
}

ConfirmChangeStatusForm.propTypes = {
  clickChangeStatus: PropTypes.func,
  open: PropTypes.bool,
}
ConfirmChangeStatusForm.defaultProps = {
  clickChangeStatus: () => {},
  open: false,
}

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;

    div:nth-child(1) {
      margin-right: 12px;
    }
`

const DescWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const DescText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`

const DescItem = styled(DescText)`
  color: #D44B49;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/confirm-change-status.js